export const REDUCER_NAME = 'appointment'

export const APPOINTMENT_TYPE_LIST = [
    {
        id: 'scan',
        value: 'Scan',
    },
    {
        id: 'implant-scan',
        value: 'Implant Scan',
    },
    {
        id: 'ipr',
        value: 'IPR',
    },
]

export const APPOINTMENT_REASON_LIST = [
    {
        id: 'initial-scan',
        value: 'Initial Scan',
    },
    {
        id: 'refinement-scan',
        value: 'Refinement Scan',
    },
    {
        id: 'rescan',
        value: 'ReScan',
    },
    {
        id: 'refinement-rescan',
        value: 'Refinement ReScan',
    },
    {
        id: 'retainer-refinement',
        value: 'Retainer Refinement',
    },
    {
        id: 'retainer-refinement-new',
        value: 'Retainer Refinement New',
    },
]

export const ALLOWED_TASKS_FOR_APPOINTMENT_INFO = [
    'medical_check',
    'confirm_medical_check',
    'rescan_medical_check',
    'refinement_medical_check',
    'confirm_refinement_medical_check',
    'rescan',
    'prepare_retainer_files',
    'check_scans',
]



// WEBPACK FOOTER //
// ./src/modules/appointment/state/const.js